import styled from "styled-components";
import { QuoteIcon } from "ui/icons";
import { defaultThemeColors } from "ui/theme";

export const TestimonialCard = ({ testimonial }) => {
  const { name, avatar, rating, quote } = testimonial;

  return (
    <Card>
      <Deco>
        {/* <QuoteIcon /> */}
        "
      </Deco>

      <AvatarWrap>
        <Avatar src={avatar} alt={name} />
      </AvatarWrap>

      <Name>{name}</Name>

      <Stars>
        {Array.from({ length: rating }).map((_, i) => (
          <Star key={i}>★</Star>
        ))}
      </Stars>

      <Quote>"{quote}"</Quote>
    </Card>
  );
};

const Card = styled.div`
  flex: 1;
  min-width: 0;
  background-color: #F7F5F1;
  border-radius: 16px;
  padding: 32px 28px 36px 28px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  box-sizing: border-box;
`;

const Deco = styled.span`
   position: absolute;
  top: 28px;
  right: 24px;
  font-family: Georgia, serif;
  font-size: 52px;
  line-height: 1;
  color: #d4c9b0;
  user-select: none;
  pointer-events: none;
  font-weight: 700;
`;

const AvatarWrap = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  overflow: hidden;
  margin-bottom: 12px;
  flex-shrink: 0;
  border: 3px solid #ffffff;
`;

const Avatar = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center top;
  display: block;
`;

const Name = styled.p`
  font-size: 15px;
  font-weight: 500;
  color: ${defaultThemeColors.basicBlack};
  margin: 0 0 8px 0;
  text-align: center;
`;

const Stars = styled.div`
  display: flex;
  gap: 3px;
  margin-bottom: 16px;
`;

const Star = styled.span`
  font-size: 18px;
  color: ${defaultThemeColors.orange};
  line-height: 1;
`;

const Quote = styled.p`
  font-size: 13.5px;
  font-weight: 300;
  color: #3a3a3a;
  line-height: 1.7;
  margin: 0;
  text-align: left;
`;
